import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

export const NOT_FOUND_PAGE_TEST_ID = 'not-found-page';

interface PageNotFoundProps {
  headlineKey?: string;
  explanationKey?: string;
}

const PageNotFound: React.FC<PageNotFoundProps> = ({
  headlineKey = 'pageNotFound.headline',
  explanationKey = 'pageNotFound.explanation',
}) => {
  const { t } = useTranslation('common');

  return (
    <Stack
      direction="column"
      data-test-id={NOT_FOUND_PAGE_TEST_ID}
      spacing={4}
      sx={{ justifyContent: 'center', alignItems: 'center', height: '100vh' }}
    >
      <Typography variant="h2">{t(headlineKey)}</Typography>
      <Typography variant="body1">{t(explanationKey)}</Typography>
    </Stack>
  );
};

export default PageNotFound;
